import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { Paso3pagePageRoutingModule } from './paso3page-routing.module';

import { Paso3pagePage } from './paso3page.page';
import {ModalCrearTrabajadorPageModule}from '../modal-crear-trabajador/modal-crear-trabajador.module'
import {ModalBuscarTrabajadorPageModule} from '../modal-buscar-trabajador/modal-buscar-trabajador.module'
import {ModalEditarTrabajadorPageModule} from '../modal-editar-trabajador/modal-editar-trabajador.module'
import {ModalActividadesTrabajadorPageModule} from '../modal-actividades-trabajador/modal-actividades-trabajador.module'
import {MiscomponentesModule} from '../miscomponentes/componentes.module'


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    Paso3pagePageRoutingModule,
    ModalCrearTrabajadorPageModule,
    ModalBuscarTrabajadorPageModule,
    ModalEditarTrabajadorPageModule,
    ModalActividadesTrabajadorPageModule,
    MiscomponentesModule
  ],
  declarations: [
    Paso3pagePage,

  ]
})
export class Paso3pagePageModule {}
